/**
 * Экраны состояния и всплывающие сообщения.
 *
 * Любая ошибка здесь показывается человеку по-русски и с указанием, что делать
 * дальше. Карта, которая молча не загрузилась, неотличима от сломанной.
 */

import { clear, el } from "./dom";

export function showLoading(container: HTMLElement, message: string): void {
  clear(container);
  container.hidden = false;
  container.className = "overlay overlay--loading";
  container.append(
    el("div", { class: "overlay__spinner", attrs: { "aria-hidden": "true" } }),
    el("p", { class: "overlay__message", text: message }),
  );
}

export function showError(container: HTMLElement, title: string, hint: string): void {
  clear(container);
  container.hidden = false;
  container.className = "overlay overlay--error";
  container.append(
    el(
      "div",
      { class: "overlay__box", attrs: { role: "alert" } },
      el("h2", { class: "overlay__title", text: title }),
      el("p", { class: "overlay__hint", text: hint }),
      el("button", {
        class: "button",
        text: "Повторить",
        attrs: { type: "button" },
        on: {
          click: () => {
            window.location.reload();
          },
        },
      }),
    ),
  );
}

export function hideOverlay(container: HTMLElement): void {
  container.hidden = true;
  clear(container);
}

let toastTimer: number | undefined;

export function toast(message: string): void {
  let node = document.querySelector<HTMLElement>(".toast");
  if (!node) {
    node = el("div", { class: "toast", attrs: { role: "status", "aria-live": "polite" } });
    document.body.appendChild(node);
  }
  node.textContent = message;
  node.classList.add("toast--visible");

  if (toastTimer !== undefined) window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => {
    node?.classList.remove("toast--visible");
  }, 2600);
}
